import React from 'react'
import Navbar from '../navbar/Navbar'

const Header = () => {
  return (
    <div>
        <Navbar/>
    </div>
  )
}

export default Header